export default __webpack_public_path__ + "static/heartopener_header-32ddc5fdf41d05effc67dc6c97f660c9.png";